// extracted by mini-css-extract-plugin
export default {"title":"styles__title___8ia3t"};